export const formatPrice = (value: number) => {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

export const formatCurrency = (value: number) => {
  if (value >= 0) {
    return `Rp ${formatPrice(value)}`;
  }
  return `- Rp ${formatPrice(Math.abs(value))}`;
};
